import React, { useEffect } from 'react';
import Isotope from "isotope-layout";
import GLightbox from "glightbox";
import Swiper from "swiper";
import imagesLoaded from 'imagesloaded';
import Footer1 from '../navbar/Footer1';


const Press = () => {
  useEffect(() => {
    const initIsotope = () => {
      let portfolioContainer = document.querySelector(".isotope-container");
      if (portfolioContainer) {
        let portfolioIsotope = new Isotope(portfolioContainer, {
          itemSelector: ".portfolio-item",
          layoutMode: "masonry",
        });

        let portfolioFilters = document.querySelectorAll(".portfolio-filters li");

        portfolioFilters.forEach((filter) => {
          filter.addEventListener("click", function (e) {
            e.preventDefault();
            portfolioFilters.forEach((el) => {
              el.classList.remove("filter-active");
            });
            this.classList.add("filter-active");

            portfolioIsotope.arrange({
              filter: this.getAttribute("data-filter"),
            });
          });
        });

        // Trigger layout after all images have loaded
        imagesLoaded(portfolioContainer, () => {
          portfolioIsotope.layout();
        });
      }
    };

    const initLightbox = () => {
      GLightbox({
        selector: ".glightbox",
      });
    };

    const initSlider = () => {
      new Swiper(".portfolio-details-slider", {
        speed: 400,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
      });
    };

    // Initialize Isotope
    initIsotope();

    // Initialize Lightbox
    initLightbox();

    // Initialize Slider
    initSlider();
  }, []);

  return (
    <div>
      <div className="page-title dark-background " style={{ backgroundImage: 'url(/assets/img/Bannerimages/pressheader.jpg)' }}>
        <div className="container position-relative">
          <h1 className="works-banner" >Press</h1>
          <nav className="breadcrumbs">
            {/* <ol>
              <li><Link to="/">Home</Link></li>
              <li className="current">Press</li>
            </ol> */}
          </nav>
        </div>
      </div>
       <div className="container section-title">
          <h2>Press</h2>
        </div>

    
<Footer1/>


    </div>
  )
}

export default Press